<template>
    <section>
        <iframe :src="iframeUrl" width="100%" height="196px" max-height="196px" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </section>
</template>

<script>
import { useRoute } from 'vue-router'
import client from "../client/client";
export default {
    name: "Youtube",
    data: function () {
        const route = useRoute()
        const { query } = route
        return {
            loading: true,
            iframeUrl: query.iframeUrl ? query.iframeUrl : ""
        }
    },
    methods: {
    },
    async mounted() {
        
    },
}
</script>

<style scoped>
    iframe{
        overflow: hidden;
    }
</style>
